import { render, staticRenderFns } from "./CreateManagedUserModal.vue?vue&type=template&id=60ded9fe&"
import script from "./CreateManagedUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateManagedUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports